import { render, staticRenderFns } from "./CoregConsentCheckbox.vue?vue&type=template&id=592de728&"
import script from "./CoregConsentCheckbox.vue?vue&type=script&lang=ts&"
export * from "./CoregConsentCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./CoregConsentCheckbox.vue?vue&type=style&index=0&id=592de728&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports